<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col">
        <h1>Eligibility Details</h1>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row summary-header pt-2">
        <div class="col-6">
          <h5>PLAN SUMMARY</h5>
        </div>
        <div v-if="insuranceBenefitDetails.planDateInformation || visitInsuranceBenefitDetails.planDateInformation" class="col-6">
          <h5>PLAN DATE INFORMATION</h5>
        </div>
      </div>
      <div class="row summary py-2">
        <div v-if="visitInsuranceBenefitDetails.insurancePlan" class="patient-info col-4">
          <div v-if="visitInsuranceBenefitDetails.insuredFirstName"><span class="field-label">Subscriber Name: </span>{{visitInsuranceBenefitDetails.insuredFirstName + ' ' + visitInsuranceBenefitDetails.insuredLastName}}</div>
          <div><span class="field-label">Insurance Plan: </span>{{visitInsuranceBenefitDetails.insurancePlan}}</div>
          <div v-if="visitInsuranceBenefitDetails.planInformation">
          <div v-if="visitInsuranceBenefitDetails.planInformation.groupDescription"> <span class="field-label">Group Description:</span> {{visitInsuranceBenefitDetails.planInformation.groupDescription}}</div>
          <div v-if="visitInsuranceBenefitDetails.planInformation.groupNumber"> <span class="field-label">Group Number: </span>{{visitInsuranceBenefitDetails.planInformation.groupNumber}}</div>
          <div v-if="visitInsuranceBenefitDetails.planInformation.planNetworkIdDescription"> <span  class="field-label">Network ID Description: </span>{{visitInsuranceBenefitDetails.planInformation.planNetworkIdDescription}}</div>
          <div v-if="visitInsuranceBenefitDetails.planInformation.planNetworkIdNumber"> <span  class="field-label">Network ID Number: </span>{{visitInsuranceBenefitDetails.planInformation.planNetworkIdNumber}}</div>
          <div v-if="visitInsuranceBenefitDetails.planInformation.planNumber"> <span  class="field-label">Plan Number: </span>{{visitInsuranceBenefitDetails.planInformation.planNumber}}</div>
          <div v-if="visitInsuranceBenefitDetails.planInformation.planType"> <span  class="field-label">Plan Type: </span>{{visitInsuranceBenefitDetails.planInformation.planType}}</div>
          </div>
          </div>
        <div v-if="insuranceBenefitDetails.insurancePlan" class="patient-info col-4">
          <div v-if="insuranceBenefitDetails.insuredFirstName"><span class="field-label">Patient Name: </span>{{insuranceBenefitDetails.insuredFirstName + ' ' + insuranceBenefitDetails.insuredLastName}}</div>
          <div><span class="field-label">Insurance Plan: </span>{{insuranceBenefitDetails.insurancePlan}}</div>
          <div v-if="insuranceBenefitDetails.planInformation">
          <div v-if="insuranceBenefitDetails.planInformation.groupDescription"> <span class="field-label">Group Description:</span> {{insuranceBenefitDetails.planInformation.groupDescription}}</div>
          <div v-if="insuranceBenefitDetails.planInformation.groupNumber"> <span class="field-label">Group Number: </span>{{insuranceBenefitDetails.planInformation.groupNumber}}</div>
          <div v-if="insuranceBenefitDetails.planInformation.planNetworkIdDescription"> <span  class="field-label">Network ID Description: </span>{{insuranceBenefitDetails.planInformation.planNetworkIdDescription}}</div>
          <div v-if="insuranceBenefitDetails.planInformation.planNetworkIdNumber"> <span  class="field-label">Network ID Number: </span>{{insuranceBenefitDetails.planInformation.planNetworkIdNumber}}</div>
          <div v-if="insuranceBenefitDetails.planInformation.planNumber"> <span  class="field-label">Plan Number: </span>{{insuranceBenefitDetails.planInformation.planNumber}}</div>
          <div v-if="insuranceBenefitDetails.planInformation.planType"> <span  class="field-label">Plan Type: </span>{{insuranceBenefitDetails.planInformation.planType}}</div>
          </div>
          </div>
        <div class="col-2"></div>
        <div class="col-6 pl-0">
          <div v-if="insuranceBenefitDetails.planDateInformation" class="patient-info col-6">
            <div v-if="insuranceBenefitDetails.planDateInformation.eligibilityBegin"> <span class="field-label">Eligibility Begin Date:</span> {{formatDate(insuranceBenefitDetails.planDateInformation.eligibilityBegin)}}</div>
            <div v-if="insuranceBenefitDetails.planDateInformation.plan"> <span class="field-label">Plan: </span>{{insuranceBenefitDetails.planDateInformation.plan}}</div>
            <div v-if="insuranceBenefitDetails.planDateInformation.planBegin"> <span  class="field-label">Plan Begin Date: </span>{{formatDate(insuranceBenefitDetails.planDateInformation.planBegin)}}</div>
            <div v-if="insuranceBenefitDetails.planDateInformation.service"> <span  class="field-label">Service Date: </span>{{formatDate(insuranceBenefitDetails.planDateInformation.service)}}</div>
          </div>
          <div v-if="visitInsuranceBenefitDetails.planDateInformation" class="patient-info col-6">
            <div v-if="visitInsuranceBenefitDetails.planDateInformation.eligibilityBegin"> <span class="field-label">Eligibility Begin Date:</span> {{formatDate(visitInsuranceBenefitDetails.planDateInformation.eligibilityBegin)}}</div>
            <div v-if="visitInsuranceBenefitDetails.planDateInformation.plan"> <span class="field-label">Plan: </span>{{visitInsuranceBenefitDetails.planDateInformation.plan}}</div>
            <div v-if="visitInsuranceBenefitDetails.planDateInformation.planBegin"> <span  class="field-label">Plan Begin Date: </span>{{formatDate(visitInsuranceBenefitDetails.planDateInformation.planBegin)}}</div>
            <div v-if="visitInsuranceBenefitDetails.planDateInformation.service"> <span  class="field-label">Service Date: </span>{{formatDate(visitInsuranceBenefitDetails.planDateInformation.service)}}</div>
          </div>
        </div>
      </div>
      <div class="holder" v-for="(service, index) in sortedServices" :key="'service-' + index">
        <div class="row benefit-header mt-4">
          <div class="header-caret" @click.prevent="toggleServices(service)"><h5 class="label mr-2">{{service.serviceName}}</h5>
          <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingServiceDetails"/>
          <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingServiceDetails"/>
          </div>
        </div>
        <transition-group name="slide"> <div v-for="(services, index) in service.services" :key="'services-' + index">
          <div v-show="showingServiceDetails.includes(service)" class="row">
          <div class="service-name col-2 pb-5 pt-2">
        {{ services.name}}
        </div>
          <div class="col-6 benefit-row">
            <div class="my-2" v-if="services.coverageLevel"><span class="field-label">Coverage Level: </span> {{ services.coverageLevel}}</div>
            <div class="my-2" v-if="services.insuranceType"><span class="field-label">Insurance Type: </span>{{services.insuranceType}}</div>
            <div class="my-2" v-if="services.inNetwork"><span class="field-label">In Network: </span>{{isInNetwork(services.inNetwork)}}</div>
            <div class="my-2" v-if="services.serviceName"><span class="field-label">Service Type: </span> {{services.serviceName}}</div>
            <div class="my-2" v-for="(benefit, index) in services.benefits" :key="'benefit-' + index">
              <div v-if="benefit.label !== 'Percent'"><span class="field-label">{{benefit.label}}:</span> {{benefit.value}}</div>
              <div v-if="benefit.label === 'Percent'"><span class="field-label">{{benefit.label}}:</span> {{formatPercent(benefit.value)}}</div>
            </div></div>
            <div class="col-4 benefit-row"></div>
          </div>
        </div>
        </transition-group>
      </div>
      </div>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
  </div>
</template>

<script>
  import api from '@/services/api'
  import moment from 'moment'
  import LoadingModal from '@/components/LoadingModal.vue'
  export default {
    name: 'InsuranceBenefits',
    components: { LoadingModal },

    props: {
      id: {
        type: Number,
        required: false
      },
      mode: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        insuranceBenefitDetails: {},
        visitInsuranceBenefitDetails: {},
        sortedServices: {},
        showingServiceDetails: [],
        showingLoadingModal: false
      }
    },
    methods: {
      loadInsuranceBenefits () {
        if (this.mode === 'estimate') {
          this.showingLoadingModal = true
          this.errors = []
          api.get('/Dashboard/InsuranceBenefitDetails/' + this.id).then(response => {
            this.showingLoadingModal = false
            this.insuranceBenefitDetails = response.data
            this.sortedServices = this.insuranceBenefitDetails.services.sort((a, b) => {
              return a.serviceName.localeCompare(b.serviceName)
            })
          }).catch(error => {
            this.showingLoadingModal = false
            if (!this.$store.canHandleNetworkError(error)) {
              this.$log.error('Error attempting to load insurance: ' + error.message, error)
              this.errors = ['Error loading insurance: ' + error.message]
            }
          })
        }
      },
      loadVisitInsuranceBenefits () {
        if (this.mode === 'visit') {
          this.showingLoadingModal = true
          this.errors = []
          api.get('/Dashboard/VisitInsuranceBenefitDetails/' + this.id).then(response => {
            this.showingLoadingModal = false
            this.visitInsuranceBenefitDetails = response.data
            this.sortedServices = this.visitInsuranceBenefitDetails.services.sort((a, b) => {
              return a.serviceName.localeCompare(b.serviceName)
            })
          }).catch(error => {
            this.showingLoadingModal = false
            if (!this.$store.canHandleNetworkError(error)) {
              this.$log.error('Error attempting to load insurance: ' + error.message, error)
              this.errors = ['Error loading insurance: ' + error.message]
            }
          })
        }
      },
      isInNetwork (inNetwork) {
        if (inNetwork === true) {
          return 'Yes'
        }
        if (inNetwork === false) {
          return 'No'
        }
      },
      toggleServices (service) {
        if (this.showingServiceDetails.includes(service)) {
          this.showingServiceDetails.splice(this.showingServiceDetails.indexOf(service), 1)
        } else {
          this.showingServiceDetails.push(service)
        }
      },
      formatPercent (number) {
        if (number) {
          return number * 100 + '%'
        }
      },

      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY')
        } else {
          return ''
        }
      }
    },
    created () {
      this.loadInsuranceBenefits()
      this.loadVisitInsuranceBenefits()
    }
  }
</script>

<style scoped>

.summary-header {
  border-top: 1px solid #FFA800;
  background-color: #f9f9f9;
}
.summary-header h5 {
  color: #001859;
}
.summary {
  border-top: 1px solid #FFA800;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dee2e6;
}
.patient-info {
  font-size: 16.8px;
}

.benefit-header {
  border-bottom: 1px solid #dee2e6;
}

.benefit-header div {
  padding: 0.75rem;
  vertical-align: bottom;
  font-weight: bold;
  border-collapse: collapse;
}

.benefit-row .column {
  padding: 0.75rem;
  vertical-align: bottom;
  border-collapse: collapse;
}

.benefit-row {
  border-bottom: 1px solid #dee2e6;
  background-color: #f9f9f9;
}

.label {
  color: #FF4600;
  font-weight: bold;
  font-size: 16.8px;
}

.header-caret {
  cursor: pointer;
  display: flex;
}

.header-caret:hover {
  text-decoration: underline;
  text-decoration-color: #FF4600;
}
.service-name {
  background-color: #FFDED1;
  font-weight: 500;
  border-bottom: 1px solid #E3C6BD;
}
</style>
